<template>
    <div>
        <top-bar-secondary>
            <template v-slot:module-action-right>
                <b-navbar-nav v-if="!isEnhancedLayout" class="ml-auto">
                    <b-nav-form
                        @click="$refs['select-billing'].focus()"
                        @contextmenu="rightClickHandler"
                        class="ml-auto"
                    >
                        <vet-select-billing
                            ref="select-billing"
                            :key="'search' + searchItemKey"
                            :focus-onload="true"
                            class="mr-sm-2 w-100 search nav-search show-actions"
                        />
                    </b-nav-form>
                </b-navbar-nav>
            </template>
        </top-bar-secondary>

        <content-wrapper>
            <router-view
                @redirect-to-dashboard="redirectToDashboard"
            ></router-view>
        </content-wrapper>
    </div>
</template>

<script>
import VetSelectBilling from "@/module/commons/vet-select-billing";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";
import ContentWrapper from "@/module/layout/content-wrapper.vue";

export default {
    components: {
        VetSelectBilling,
        TopBarSecondary,
        ContentWrapper
    },
    props: {},
    data() {
        return {
            searchItemKey: 0,
            searchItem: null
        };
    },
    computed: {
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    },
    watch: {},
    mounted() {},
    destroyed() {},
    methods: {
        goToAppPage() {
            window.open(
                `${process.env.CI_APPS}inventory/item/view/${this.itemDetails.encoded_id}`,
                "_blank"
            );
        },
        redirectToDashboard() {
            this.$router.replace("/inventory/dashboard");
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-billing"].focus();
            }
        }
    }
};
</script>
